import { Icons, tokens } from '@cast/design-system';

const escalationBadgeSx = {
  position: 'absolute',
  bottom: 0,
  right: 0,
  transform: 'translate(50%, 50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: tokens.theme.bg.structural.surface,
  border: '1px solid',
  borderColor: tokens.theme.border.structural.neutral,
  borderRadius: '50%',
  padding: '1px',
  color: tokens.theme.fg.structural.primary,
} as const;

const blockedBadgeSx = {
  ...escalationBadgeSx,
  color: tokens.theme.fg.structural.secondary,
} as const;

export const useEscalationBadgeState = ({
  isEscalation,
  isBlocked,
}: {
  isEscalation: boolean;
  isBlocked: boolean;
}) => {
  if (!isEscalation && !isBlocked) {
    return null;
  }

  if (isBlocked) {
    return {
      title: 'Forbidden access',
      sx: blockedBadgeSx,
      Icon: Icons.Lock,
    };
  }

  return {
    title: 'Escalation access',
    sx: escalationBadgeSx,
    Icon: Icons.ShieldWarning,
  };
};
